import type { Components, ExtraProps } from 'react-markdown'

import { parsePipeTable } from './chat-markdown-table-parser.helper'

const TableWrapper: React.FC<React.HTMLAttributes<HTMLTableElement>> = (props) => (
  <div className="chat-markdown-table-wrapper">
    <table {...props} />
  </div>
)

interface CodeBlockProps extends React.HTMLAttributes<HTMLElement>, ExtraProps {
  inline?: boolean
}

const CodeBlock: React.FC<CodeBlockProps> = ({ inline, className, children, ...rest }) => {
  if (!inline && className === 'language-table') {
    const text = String(children).replace(/\n$/, '')
    const tableData = parsePipeTable(text)

    if (tableData) {
      return (
        <div className="chat-markdown-table-wrapper">
          <table>
            <thead>
              <tr>
                {tableData.headerList.map((header, i) => (
                  <th key={i}>{header}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {tableData.rowList.map((row, rowIdx) => (
                <tr key={rowIdx}>
                  {tableData.headerList.map((_, colIdx) => (
                    <td key={colIdx}>{row[colIdx] ?? ''}</td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )
    }
  }

  return (
    <code className={className} {...rest}>
      {children}
    </code>
  )
}

export const chatMarkdownComponents: Components = {
  table: TableWrapper,
  code: CodeBlock,
}
